import React, {useMemo} from 'react';
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from "@mui/icons-material/Logout";
import DialogWithMenuBurgerMenu from "./DialogWithMenuBurgerMenu";
import DeleteConfirmation from "../DeleteConfirmation";

const DialogWithMenuContainer = ({children, maxWidth = 'xl', onExit, appBarItems, isDesktop, showText, onDelete, deleteDisabled, logoutExit, headerText}) => {

    const toolBarItems = useMemo(() => appBarItems ? appBarItems.filter(i => isDesktop || !i.burgerMenu) : [], [appBarItems, isDesktop])
    const burgerItems = useMemo(() => appBarItems ? appBarItems.filter(i => !isDesktop && i.burgerMenu) : [], [appBarItems, isDesktop])

    const renderAppBarItem = (item, key) => (
        <Button
            key={key}
            color="inherit"
            onClick={item.onClick}
            disabled={item.disabled}
            data-testid={item.testId}
            sx={{
                minWidth: "auto",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: 0.5,
            }}
        >
            {item.icon ? item.icon : null}
            {item.icon && !showText ? (
                <Typography variant="h6" component="span" sx={{ flexGrow: 1, lineHeight: 1 }}>
                    {item.count ? `(${item.count})` : null}
                </Typography>
            ) : null}
            {item.text && (showText || !item.icon) ? (
                <Typography variant="h6" component="span" sx={{ flexGrow: 1 }}>
                    {item.text}
                </Typography>
            ) : null}
        </Button>
    );

    const deleteButtonMargin = useMemo(() => toolBarItems?.length || burgerItems?.length ? '2em' : 0, [toolBarItems, burgerItems])

    return (
        (<Box
            sx={{
                minHeight: '100vh',
                bgcolor: "background.default",
                display: "flex",
                flexDirection: "column",
                color: "text.primary"
            }}>
            <AppBar>
                <Toolbar>
                    {headerText ? <Typography variant="h6" component="h1">{headerText}</Typography> : null}
                    {toolBarItems?.length ? toolBarItems.map((item, idx) => renderAppBarItem(item, idx)) : null}
                    {burgerItems?.length ? <DialogWithMenuBurgerMenu appBarItems={burgerItems} /> : null}
                    {onDelete ? <DeleteConfirmation onDelete={onDelete} disabled={deleteDisabled} sx={{marginLeft: deleteButtonMargin}}/>  : null}
                    <Box sx={{
                        flexGrow: 1
                    }}></Box>
                    {onExit ? <IconButton
                        size="large"
                        color="inherit"
                        onClick={onExit}
                    >
                        {logoutExit ? <LogoutIcon /> : <CloseIcon/>}
                    </IconButton> : null}
                </Toolbar>
            </AppBar>
            <Container maxWidth={maxWidth} sx={{flex: 1, marginTop: '70px'}}>
                {children}
            </Container>
        </Box>)
    );
}

export default DialogWithMenuContainer;
